export default {
    LOGIN_IN (state, data) {
        state.UserToken = data.employ_info.token;
        state.loginDatas = data.employ_info;
        state.schoolList = data.schoolList;
        state.school_id = data.schoolList[0].school_id;
        state.sell_type = data.schoolList[0].sell_type;
        state.post_permission_code = data.schoolList[0].post_permission_code;
    },
    LOGIN_OUT (state) {
        state.UserToken = "";
        state.loginDatas = "";
        state.schoolList = "";
        state.school_id = "";
        state.post_permission_code = "";
        sessionStorage.clear();
    },
    SET_ShoolId (state, data) {
        state.school_id = data.school_id;
        state.sell_type = data.sell_type;
    },
    SET_post_permission_code (state, data) {
        state.post_permission_code = data;
    },
    toggleNavCollapse (state) {
        state.isSidebarNavCollapse = !state.isSidebarNavCollapse;
    },
    setCrumbList (state, list) {
        state.crumbList = list;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js